const C = {
  name: "ToggleFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11H18.5C21.5376 11 24 8.53757 24 5.5C24 2.46243 21.5376 0 18.5 0H5.5ZM18.5 8C17.1193 8 16 6.88071 16 5.5C16 4.11929 17.1193 3 18.5 3C19.8807 3 21 4.11929 21 5.5C21 6.88071 19.8807 8 18.5 8Z" fill="currentColor"/>
<path d="M5.5 13C2.46243 13 0 15.4624 0 18.5C0 21.5376 2.46243 24 5.5 24H18.5C21.5376 24 24 21.5376 24 18.5C24 15.4624 21.5376 13 18.5 13H5.5ZM8 18.5C8 19.8807 6.88071 21 5.5 21C4.11929 21 3 19.8807 3 18.5C3 17.1193 4.11929 16 5.5 16C6.88071 16 8 17.1193 8 18.5Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as ToggleFilled
};
